/**
 * Inverse of {@link getImageDisplayUrl}. Normalize a (possibly absolute) image
 * URL back to the server-relative `/storage/...` path the bos-api stores and
 * expects on write (`PUT /categories/{id}` etc.).
 *
 * The form seeds its image field with the *display* (API-host-absolute) URL so
 * the `<img>` preview renders; submitting that verbatim would persist an
 * environment-specific host into the saved data. This strips the API host back
 * off before the value is sent.
 *
 * - Returns `null`/`undefined` unchanged so callers can pass straight through.
 * - `data:` URLs (cropper previews) and already-relative paths pass through
 *   verbatim.
 * - Absolute URLs pointing at a *different* host are left intact (we only own
 *   the bos-api host); foreign URLs are returned as-is.
 */
export const getImageStoragePath = (
    url: string | null | undefined,
    apiBaseUrl: string,
): string | null | undefined => {
    if (url === null || url === undefined) {
        return url;
    }
    if (
        url.startsWith('data:') ||
        (!url.startsWith('http://') && !url.startsWith('https://'))
    ) {
        return url;
    }
    try {
        const parsed = new URL(url);
        const base = new URL(apiBaseUrl);
        if (parsed.host === base.host) {
            return `${parsed.pathname}${parsed.search}${parsed.hash}`;
        }
        return url;
    } catch {
        return url;
    }
};
